<template>
  <div class="customerQuotationDetail">
    <van-form label-width="120px" v-if="content">
      <div class="title">{{ $t.freightInquiry.quotationDetail }}</div>

      <van-field
        v-model="content.CustomerNumber"
        :label="$t.freightInquiry.customerNumber"
        readonly
      />

      <van-field
        v-model="content.CompanyName"
        :label="$t.freightInquiry.customerCompanyName"
        readonly
      />

      <van-field v-model="content.RegionName" :label="$t.freightInquiry.area" readonly />

      <van-field v-model="content.CountryName" :label="$t.meta.country" readonly />

      <van-field v-model="content.CityName" :label="$t.meta.city" readonly />

      <van-field v-model="content.BCName" :label="$t.freightInquiry.bcName" readonly />

      <van-field v-model="content.AWName" :label="$t.freightInquiry.awWay" readonly />

      <van-field
        v-model="content.Currency"
        :label="$t.freightInquiry.dCurrnecy"
        readonly
      />

      <van-field
        v-model="content.CurrencySymbol"
        :label="$t.freightInquiry.dCurrnecySymbol"
        readonly
      />

      <van-field v-model="content.Weight" :label="$t.freightInquiry.weight" readonly />

      <van-field v-model="content.Volume" :label="$t.freightInquiry.volume" readonly />

      <van-field
        v-model="content.ShipmentCount"
        :label="$t.freightInquiry.shipmentCount"
        readonly
      />

      <van-field
        v-model="content.BillCount"
        :label="$t.freightInquiry.billCount"
        readonly
      />

      <van-field
        v-model="content.CifGoodsValue"
        :label="$t.freightInquiry.cifGoodsValue"
        readonly
      />

      <van-field
        v-model="content.PiecesNumber"
        :label="$t.freightInquiry.piecesNumber"
        readonly
      />

      <van-field
        v-model="content.StorageOverdueDays"
        :label="$t.freightInquiry.storageOverdueDays"
        readonly
      />

      <van-field
        v-model="content.Conatiner20"
        :label="$t.freightInquiry.conatiner20"
        readonly
      />

      <van-field
        v-model="content.Conatiner40"
        :label="$t.freightInquiry.conatiner40"
        readonly
      />

      <van-field
        v-model="content.Conatiner40HQ"
        :label="$t.freightInquiry.conatiner40HQ"
        readonly
      />

      <div class="custom-field">
        <div class="custom-field-label">{{ $t.freightInquiry.isCustomsInspection }}</div>
        <div class="custom-field-value">
          <span v-if="content.IsCustomsInspection == 1">{{ $t.meta.yes }}</span>
          <span v-else>{{ $t.meta.no }}</span>
        </div>
      </div>

      <van-field
        v-model="content.OperationNotes"
        :label="$t.freightInquiry.notes"
        readonly
      />

      <van-field
        v-model="content.TotalSalesPrice"
        :label="$t.freightInquiry.totalCostPrice"
        readonly
      />

      <div class="title">{{ $t.freightInquiry.feeSchedule }}</div>

      <div class="multi-table" v-if="content.ChargedItemList">
        <div v-for="(item, index) in content.ChargedItemList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title">No.{{ index + 1 }}</div>
          </div>

          <van-field
            v-model="item.ItemName"
            :label="$t.freightInquiry.itemName"
            readonly
          />

          <van-field
            v-model="item.UnitName"
            :label="$t.freightInquiry.unitName"
            readonly
          />

          <div class="custom-field">
            <div class="custom-field-label">{{ $t.freightInquiry.isMandatoryItem }}</div>
            <div class="custom-field-value">
              <span v-if="item.IsMandatoryItem == 1">{{
                $t.freightInquiry.mandatory1
              }}</span>
              <span v-if="item.IsMandatoryItem == 2">{{
                $t.freightInquiry.mandatory2
              }}</span>
              <span v-if="item.IsMandatoryItem == 3">{{
                $t.freightInquiry.mandatory3
              }}</span>
            </div>
          </div>

          <van-field
            v-model="item.SalesPrice"
            :label="$t.freightInquiry.costPrice"
            readonly
          />
        </div>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field } from "vant";

Vue.use(Form).use(Field);

export default {
  name: "customerQuotationDetail",
  data() {
    return {
      SQId: null,
      content: null,
    };
  },
  created() {
    const { SQId } = this.$route.query;
    if (SQId) {
      this.SQId = SQId;
      this.getCustomerSupplierQuotationBySQId();
    }
  },
  methods: {
    getCustomerSupplierQuotationBySQId() {
      this.$commonMethod.showLoading();
      var param = {
        SQId: this.SQId,
      };
      return new Promise((resolve) => {
        this.$api.myCustomer
          .getCustomerSupplierQuotationBySQId(param)
          .then((res) => {
            this.content = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.customerQuotationDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      border-bottom: 1px solid #ebedf0;
      .multi-table-title {
        font-size: 14px;
        color: #999;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 100%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
  .custom-field {
    font-size: 14px;
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .custom-field-label {
      width: 120px;
      font-size: 14px;
      margin-right: 12px;
      color: #646566;
      display: inline-block;
      vertical-align: middle;
    }
    .custom-field-value {
      width: 50%;
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>
